import { ViewType } from '@baserow/modules/database/viewTypes'

/**
 * Lo comun a las tres vistas propias (Kanban, Calendario y Linea de tiempo).
 *
 * Es el gemelo de `mixins/vistaMG.js`: aquel junta lo que comparten los
 * COMPONENTES, este lo que comparten sus TIPOS DE VISTA. Hasta ahora estas
 * cinco piezas estaban copiadas tres veces, palabra por palabra — 165 lineas
 * que habia que corregir en tres sitios cada vez.
 *
 * Todo lo de aqui existe por lo mismo: estas tres vistas NO tienen store. Sus
 * opciones de campo viven en el propio componente, que es lo que permite que
 * sean ~300 lineas en vez de varios miles. El core da por hecho que hay store
 * y por eso hay que pisarle estos metodos.
 */
export class VistaMGViewType extends ViewType {
  /**
   * Los metadatos de fila (por ejemplo, cuantos comentarios tiene) tambien se
   * guardan en el store del tipo de vista, que estas no tienen. La
   * implementacion del core despacharia a un modulo inexistente y reventaria.
   * Aqui basta con no hacer nada: la vista recarga sus filas cuando algo cambia
   * de fuera, que es lo que avisa `avisarCambioDeFilas`.
   */
  async updateRowMetadata() {}

  /**
   * Los campos visibles, para los menus del core que preguntan por ellos.
   *
   * La implementacion de ViewType lee las opciones de campo de un store con el
   * nombre del tipo de vista ('view/kanban_mg/getAllFieldOptions'). Sin este
   * override el getter sale undefined y el filtro revienta con "Cannot read
   * properties of undefined" — una pantalla de Server Error al abrir el menu de
   * color.
   *
   * Se devuelven todos los campos, con el primario primero. Quien usa esto son
   * avisos y listas de los menus, no el dibujo de la vista, asi que de mas es
   * mejor que de menos.
   */
  getVisibleFieldsInOrder(context, fields, view, storePrefix = '') {
    return [...fields].sort((a, b) => {
      if (a.primary !== b.primary) {
        return a.primary ? -1 : 1
      }
      return a.id - b.id
    })
  }

  /**
   * Las tres vistas dibujan con las filas que ya trajeron, asi que un cambio
   * hecho por otra persona (que llega por websocket) no se veria hasta recargar.
   * El componente escucha este aviso en el bus y vuelve a pedir sus filas.
   */
  avisarCambioDeFilas(context, tableId) {
    context.app.$bus.$emit('mg-filas-cambiadas', { tableId })
  }

  rowCreated(context, tableId) {
    this.avisarCambioDeFilas(context, tableId)
  }

  rowUpdated(context, tableId) {
    this.avisarCambioDeFilas(context, tableId)
  }

  rowDeleted(context, tableId) {
    this.avisarCambioDeFilas(context, tableId)
  }
}
